export default __webpack_public_path__ + "static/media/bangle.919a5c77.png";